import { render, staticRenderFns } from "./TeacherActivePageTableControl.vue?vue&type=template&id=18e24502&scoped=true&"
import script from "./TeacherActivePageTableControl.vue?vue&type=script&lang=js&"
export * from "./TeacherActivePageTableControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e24502",
  null
  
)

export default component.exports